/**
 * 大屏模块·第 2 组（src/views/bigScreen，第 22~42 个文件）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / 其他 en/modules/*.js）──
  '提示': 'Notice',
  '错误': 'Error',
  '系统首页': 'Home',
  '退出登录': 'Sign Out',
  '返回': 'Back',
  '刷新': 'Refresh',
  '语言': 'Language',
  '正常': 'Normal',
  '户': 'Household(s)',
  '个': 'pcs',
  '件': 'pcs',
  '元': 'CNY',
  '万元': '10K CNY',
  '0元': '0 CNY',
  '昨日': 'Yesterday',
  '今日': 'Today',
  '上月': 'Last Month',
  '本月': 'This Month',
  '日': 'Day',
  '月': 'Month',
  '总计/故障率': 'Total / Fault Rate',
  '换表': 'Meter Replacement',
  '故障报修': 'Fault Repair',
  '工程报装': 'Engineering Installation',

  // ── MeterRealingCenter.vue 抄表中心 ──
  '近七日抄见率{rate}%': 'Meter Reading Rate (Last 7 Days): {rate}%',
  '本月任务': 'Tasks This Month',
  '水表总数': 'Total Meters',
  '远传表数': 'Remote Meters',
  '非远传表数': 'Non-remote Meters',
  '开阀数': 'Valves Opened',
  '关阀数': 'Valves Closed',

  // ── RealTimeDataOfPumpRoom.vue 泵房实时数据 ──
  '泵房实时数据': 'Real-time Pump Room Data',
  '泵房名称': 'Pump Room Name',
  '进水压力(MPa)': 'Inlet Pressure (MPa)',
  '最大出水压力(MPa)': 'Max Outlet Pressure (MPa)',
  '出水流量(m³/h)': 'Outlet Flow (m³/h)',
  '水质监控': 'Water Quality Monitoring',
  '更新时间': 'Updated At',

  // ── SatisfactionLevel.vue 满意度 ──
  '本年满意度统计': 'Satisfaction Statistics This Year',
  '好评量': 'Positive Reviews',
  '差评量': 'Negative Reviews',
  '非常不满意': 'Very Dissatisfied',
  '不满意': 'Dissatisfied',
  '一般': 'Average',
  '满意': 'Satisfied',
  '非常满意': 'Very Satisfied',
  '满意度': 'Satisfaction',
  '评论量': 'Review Count',
  '好评率(%)': 'Positive Rate (%)',
  '评论量(个)': 'Reviews',

  // ── UsersNumberAndWaterType.vue 用水类型分析 ──
  '用水类型分析': 'Water Use Type Analysis',
  '用户总数': 'Total Users',

  // ── WaterQualityQualificationRate.vue 水质合格率 ──
  '水质合格率': 'Water Quality Compliance Rate',
  '合格率': 'Compliance Rate',

  // ── WaterSupplyMonitoring.vue 供水监控 ──
  '供水监控': 'Water Supply Monitoring',
  '年供水流量': 'Annual Water Supply Flow',
  '今日供水量': 'Today\'s Water Supply',
  '出水压力': 'Outlet Pressure',
  '瞬时流速': 'Instantaneous Flow Rate',

  // ── WorkOrderCenter.vue 工单中心 ──
  '环比': 'MoM',
  '基本指标': 'Basic Indicators',
  '本月工单(件)': 'Work Orders This Month (pcs)',
  '本周工单(件)': 'Work Orders This Week (pcs)',
  '昨日工单(件)': 'Work Orders Yesterday (pcs)',
  '待处理工单(件)': 'Pending Work Orders (pcs)',
  '本年工单总数': 'Total Work Orders This Year',
  '本年已完成': 'Completed This Year',
  '本年未完成': 'Unfinished This Year',
  '本年超时未完成': 'Overdue & Unfinished This Year',
  '本年工单完成率': 'Work Order Completion Rate This Year',

  // ── WorkOrderConstitute.vue / WorkOrderSource.vue 工单构成与来源 ──
  '工单构成分布': 'Work Order Composition',
  '总数量': 'Total',
  '工单来源': 'Work Order Source',
  '公众号': 'Official Account',
  '客服热线': 'Customer Service Hotline',

  // ── businessCenter.vue 营业中心 ──
  '营业缴费': 'Bill Payment',
  '用水统计': 'Water Use Statistics',
  '设备检测': 'Device Detection',

  // ── deviceAnalysis.vue 资产概览 ──
  '资产概览': 'Asset Overview',
  '压力表': 'Pressure Gauge',
  '液位计': 'Liquid Level Gauge',
  '水质传感器': 'Water Quality Sensor',
  '水表': 'Water Meter',

  // ── echartBMap.vue 地图气泡/信息窗口 ──
  '设备编号': 'Device No.',
  '用户姓名': 'Customer Name',
  '联系电话': 'Contact Phone',
  '安装位置': 'Installation Location',
  '阀门状态': 'Valve Status',
  '运行状态': 'Running Status',
  '欠压': 'Undervoltage',
  '有磁干扰': 'Magnetic Interference',
  '关阀': 'Close Valve',
  '开阀': 'Open Valve',
  '设备详情': 'Device Details',
  '设备详情信息': 'Device Detail Information',

  // ── echartMap.vue 地图 ──
  '地图展示': 'Map View',

  // ── faultAnalysis.vue 物联网设备分析 ──
  '物联网设备分析': 'IoT Device Analysis',
  '近三日上报率': '3-Day Reporting Rate',
  '近七日上报率': '7-Day Reporting Rate',
  '磁干扰': 'Magnetic Interference',
  '阀门故障': 'Valve Fault',

  // ── pressDeviceInfo.vue / waterDeviceInfo.vue 压力/液位 ──
  '压力': 'Pressure',
  '压力值': 'Pressure',
  '温度值': 'Temperature',
  '温度': 'Temperature',
  '液位': 'Liquid Level',
  '低位告警线': 'Low Alarm Line',
  '高位告警线': 'High Alarm Line',

  // ── shortcutMenu.vue 快捷菜单 ──
  '快捷键': 'Shortcuts',
  '切换全屏': 'Enter Fullscreen',
  '退出全屏': 'Exit Fullscreen',
  '真的要注销登录吗 ?': 'Are you sure you want to sign out?',

  // ── topHeader.vue 顶部统计 ──
  '年度总缴费': 'Annual Total Payment',
  '年度总用量': 'Annual Total Usage',

  // ── videoMonitoring.vue ──
  '视频监控': 'Video Monitoring',

  // ── waterPayDiffAnalysis.vue 营收分析 ──
  '营收分析': 'Revenue Analysis',
  '营收': 'Revenue',
}
